var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "statistics_mobile_period_filter",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "statistics_mobile_period_filter" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "statistics_mobile_period_filter_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c(
            "a",
            {
              attrs: { href: "#", id: "statistics_mobile_period_filter_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("statistics_mobile_period_filter")
                },
              },
            },
            [_c("i", { staticClass: "fas fa-arrow-left" })]
          ),
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("statisticsFilters.mobilePeriodFilter.title")) +
                " "
            ),
          ]),
          _c("div"),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _c("PeriodFilter", {
            ref: "periodFilter",
            attrs: { alwaysOpen: true },
            on: {
              periodChanged: function ($event) {
                return _vm.periodChanged($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.navigationVisible,
              expression: "navigationVisible",
            },
          ],
          staticClass: "offcanvas-footer",
        },
        [
          _c("button", { on: { click: _vm.decrementPeriod } }, [
            _c(
              "svg",
              {
                staticClass: "feather feather-arrow-left",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "22",
                  height: "22",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                }),
                _c("polyline", { attrs: { points: "12 19 5 12 12 5" } }),
              ]
            ),
          ]),
          _c("button", { on: { click: _vm.incrementPeriod } }, [
            _c(
              "svg",
              {
                staticClass: "feather feather-arrow-right",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "22",
                  height: "22",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "5", y1: "12", x2: "19", y2: "12" },
                }),
                _c("polyline", { attrs: { points: "12 5 19 12 12 19" } }),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }